


























































import { Component, Vue, Prop } from 'vue-property-decorator'
import { BRow, BCol, BCarousel, BCarouselSlide } from 'bootstrap-vue'

@Component({
  components: { BRow, BCol, BCarousel, BCarouselSlide }
})
export default class ProductImagesCarousel extends Vue {
  @Prop({ required: true, default: [] })
  private productImages!: Array<string>

  private currentSlide = 0
}
